import { useMemo } from 'react'

import { useChatConnection } from '@/context/ChatConnectionContext'
import { NotificationItem } from '@/entities/Notification/Notification'
import { transformChannelToNotification } from '@/entities/Notification/NotificationTransformers'

import { useInAppEnabledCategories } from './useInAppEnabledCategories'

interface UseChatNotificationsResult {
    notifications: NotificationItem[]
    unreadCount: number
    markAllRead: () => void
}

export const useChatNotifications = (): UseChatNotificationsResult => {
    const { client, channels, unreadCount, userId } = useChatConnection()
    const inAppEnabledCategories = useInAppEnabledCategories(userId)

    const notifications = useMemo(() => channels
        .filter(channel => channel.countUnread() > 0)
        .map(transformChannelToNotification)
        .filter(notification => inAppEnabledCategories[notification.category])
        .sort((notificationA, notificationB) => notificationB.createdAt.getTime() - notificationA.createdAt.getTime()), [channels, inAppEnabledCategories])

    const markAllRead = (): void => {
        client?.markChannelsRead().catch(error => console.error(error))
    }

    return {
        notifications,
        unreadCount,
        markAllRead,
    }
}
